class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    const allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) this.keepInSync('', this.input);
  }

  onInput(event) { this.keepInSync(event.target.value, event.target); }

  onInputFocus() {
    if (window.innerWidth < 750) this.scrollIntoView({ behavior: 'smooth' });
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => { if (input !== target) input.value = value; });
  }
}

customElements.define('main-search', MainSearch);

/* Avian full search architecture V5 - 2026-08-29
   Product-name searches use the deterministic full-catalogue title index.
   Generic category searches continue to use Shopify search results. */
(function () {
  if (window.__avianFullSearchArchitectureV5) return;
  window.__avianFullSearchArchitectureV5 = true;

  const GENERIC = new Set([
    'sofa','sofas','bed','beds','dining','table','tables','chair','chairs','lighting','light','lights','lamp','lamps',
    'cushion','cushions','painting','paintings','art','recliner','recliners','console','consoles','outdoor','bar','bars',
    'office','tv','unit','units','coffee','side','center','centre','stool','stools','cabinet','cabinets','mirror','mirrors',
    'desk','desks','bookcase','bookcases','pouffe','pouffes','ottoman','ottomans','dresser','dressers','wardrobe','wardrobes',
    'trolley','trolleys','rug','rugs','carpet','carpets','bench','benches','showcase','showcases'
  ]);

  function normalize(value) {
    let text = String(value || '').trim().toLowerCase();
    try { text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (error) {}
    return text.replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function words(value) { return normalize(value).split(' ').filter(Boolean); }

  function isGeneric(value) {
    const list = words(value);
    return list.length > 0 && list.every((word) => GENERIC.has(word));
  }

  function specificWords(value) {
    const list = words(value);
    const specific = list.filter((word) => !GENERIC.has(word));
    return specific.length ? specific : list;
  }

  function canonicalizeSearchPage() {
    if (!/\/search\/?$/.test(location.pathname)) return false;
    const url = new URL(location.href);
    const q = (url.searchParams.get('q') || '').trim();
    if (!q) return false;
    let changed = false;
    [['type','product'], ['sort_by','relevance'], ['options[prefix]','last']].forEach(([key, value]) => {
      if (url.searchParams.get(key) !== value) {
        url.searchParams.set(key, value);
        changed = true;
      }
    });
    if (changed) {
      location.replace(url.toString());
      return true;
    }
    return false;
  }

  function ensureHidden(form, name, value) {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function normalizeSearchForms() {
    document.querySelectorAll('form[action*="/search"], form[role="search"]').forEach((form) => {
      if (!form.querySelector('input[name="q"]')) return;
      ensureHidden(form, 'type', 'product');
      ensureHidden(form, 'sort_by', 'relevance');
      ensureHidden(form, 'options[prefix]', 'last');
      if (!form.dataset.avianSearchSubmitV5) {
        form.dataset.avianSearchSubmitV5 = 'true';
        form.addEventListener('submit', () => {
          ensureHidden(form, 'type', 'product');
          ensureHidden(form, 'sort_by', 'relevance');
          ensureHidden(form, 'options[prefix]', 'last');
        }, true);
      }
    });
  }

  function normalizeSearchLinks() {
    document.querySelectorAll('a[href*="/search?"]').forEach((link) => {
      try {
        const url = new URL(link.href, location.origin);
        if (!url.searchParams.get('q')) return;
        url.searchParams.set('type', 'product');
        url.searchParams.set('sort_by', 'relevance');
        url.searchParams.set('options[prefix]', 'last');
        link.href = url.toString();
      } catch (error) {}
    });
  }

  function escapeMarkup(value) {
    return String(value ?? '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[character]);
  }

  function imageAtWidth(value, width) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return String(value);
    }
  }

  function cardTitle(card) {
    return normalize(card.querySelector('h3')?.textContent || '');
  }

  function scoreTitle(title, query) {
    const t = normalize(title);
    const q = normalize(query);
    if (!t) return 99;
    if (t === q) return 0;
    if (q && t.startsWith(q)) return 1;
    const titleWords = words(t);
    const anchors = specificWords(q);
    if (words(q).length && words(q).every((word) => titleWords.some((titleWord) => titleWord.startsWith(word)))) return 2;
    if (anchors.length && anchors.every((word) => titleWords.some((titleWord) => titleWord.startsWith(word)))) return 3;
    if (q && t.includes(q)) return 4;
    return 99;
  }

  function rankVisibleShopifyProducts() {
    const grid = document.querySelector('.avian-search-grid');
    if (!grid) return;
    const query = normalize(new URL(location.href).searchParams.get('q'));
    if (!query) return;
    const cards = Array.from(grid.querySelectorAll('.avian-search-card'));
    if (cards.length < 2) return;

    cards.forEach((card, index) => {
      card.dataset.avianSearchOriginalIndexV5 = String(index);
      card.dataset.avianSearchScoreV5 = String(scoreTitle(cardTitle(card), query));
    });

    cards.sort((a, b) => {
      const delta = Number(a.dataset.avianSearchScoreV5) - Number(b.dataset.avianSearchScoreV5);
      if (delta) return delta;
      return Number(a.dataset.avianSearchOriginalIndexV5) - Number(b.dataset.avianSearchOriginalIndexV5);
    }).forEach((card) => grid.appendChild(card));
  }

  function fetchIndexPage(page) {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(`${root}collections/all`, location.origin);
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('section_id', 'avian-search-index');
    url.searchParams.set('page', String(page));
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Index ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const node = doc.querySelector('[data-avian-search-index]');
        if (!node) throw new Error('Search index section missing');
        return JSON.parse(node.textContent || '{}');
      });
  }

  function loadProductTitleIndex() {
    if (window.__avianProductTitleIndexV8) return Promise.resolve(window.__avianProductTitleIndexV8);
    if (window.__avianProductTitleIndexPromiseV8) return window.__avianProductTitleIndexPromiseV8;
    const storageKey = 'avianProductTitleIndexV8';

    try {
      const stored = sessionStorage.getItem(storageKey);
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length) {
          window.__avianProductTitleIndexV8 = parsed;
          return Promise.resolve(parsed);
        }
      }
    } catch (error) {}

    window.__avianProductTitleIndexPromiseV8 = fetchIndexPage(1)
      .then((firstPage) => {
        const pages = Math.max(1, Number(firstPage.pages) || 1);
        const requests = [];
        for (let page = 2; page <= pages; page += 1) requests.push(fetchIndexPage(page));
        return Promise.all(requests).then((rest) => [firstPage, ...rest]);
      })
      .then((pageData) => {
        const seen = new Set();
        const index = [];
        pageData.forEach((page) => {
          (page.products || []).forEach((product) => {
            if (!product || !product.handle || seen.has(product.handle)) return;
            seen.add(product.handle);
            index.push(product);
          });
        });
        window.__avianProductTitleIndexV8 = index;
        try { sessionStorage.setItem(storageKey, JSON.stringify(index)); } catch (error) {}
        return index;
      })
      .finally(() => { window.__avianProductTitleIndexPromiseV8 = null; });

    return window.__avianProductTitleIndexPromiseV8;
  }

  function rankIndexMatches(index, query) {
    const q = normalize(query);
    const qWords = words(query);
    const anchors = specificWords(query);

    return index
      .map((product, originalIndex) => {
        const title = normalize(product.title);
        const titleWords = words(product.title);
        let score = 99;
        if (title === q) score = 0;
        else if (title.startsWith(q)) score = 1;
        else if (qWords.length && qWords.every((word) => titleWords.some((titleWord) => titleWord.startsWith(word)))) score = 2;
        else if (anchors.length && anchors.every((word) => titleWords.some((titleWord) => titleWord.startsWith(word)))) score = 3;
        else if (q && title.includes(q)) score = 4;
        return { product, score, originalIndex };
      })
      .filter((entry) => entry.score < 99)
      .sort((a, b) => a.score - b.score || a.originalIndex - b.originalIndex || String(a.product.title || '').length - String(b.product.title || '').length)
      .map((entry) => entry.product);
  }

  function buildIndexedCard(product) {
    const root = window.Shopify?.routes?.root || '/';
    const title = escapeMarkup(product.title || '');
    const handle = escapeMarkup(product.handle || '');
    const rawImage = imageAtWidth(product.image, 900);
    const image = rawImage ? escapeMarkup(rawImage) : '';
    const media = image
      ? `<img src="${image}" alt="${title}" loading="lazy" width="900" height="738">`
      : '<span class="avian-search-empty-media">Avian</span>';

    return `<a class="avian-search-card" href="${root}products/${handle}" data-avian-indexed-product="${handle}">
      <div class="avian-search-media">${media}</div>
      <div class="avian-search-card-body">
        <span class="avian-search-tag">Avian Edit</span>
        <h3>${title}</h3>
        <p>View piece</p>
      </div>
    </a>`;
  }

  function ensureResultsGrid() {
    let grid = document.querySelector('.avian-search-grid');
    if (grid) return grid;
    const heading = document.querySelector('.avian-search-section-head');
    if (!heading) return null;
    grid = document.createElement('div');
    grid.className = 'avian-search-grid';
    heading.insertAdjacentElement('afterend', grid);
    return grid;
  }

  function hideNativeEmptyState() {
    document.querySelectorAll('.avian-search-helper').forEach((helper) => {
      const heading = normalize(helper.querySelector('h2')?.textContent || '');
      if (heading.startsWith('no product match')) helper.hidden = true;
    });
  }

  function updateResultCount(count, query) {
    const bar = document.querySelector('.avian-search-results-bar p');
    if (!bar) return;
    const noun = count === 1 ? 'product match' : 'product matches';
    bar.innerHTML = `<strong>${count} ${noun}</strong> matching “${escapeMarkup(query)}”`;
  }

  function updateSearchNotes(indexDriven) {
    const notes = document.querySelector('.avian-search-tools');
    if (!notes) return;
    notes.innerHTML = indexDriven
      ? '<span>Title match</span><span>Newer first</span><span>Products only</span>'
      : '<span>Best match first</span><span>Products only</span><span>Title priority</span>';
  }

  function renderIndexedFullSearch(query) {
    return loadProductTitleIndex().then((index) => {
      const matches = rankIndexMatches(index, query);
      if (!matches.length) return false;

      const grid = ensureResultsGrid();
      if (!grid) return false;
      const visible = matches.slice(0, 24);
      grid.innerHTML = visible.map(buildIndexedCard).join('');
      grid.hidden = false;
      hideNativeEmptyState();
      document.querySelectorAll('.avian-search-pagination').forEach((node) => { node.hidden = true; });
      updateResultCount(matches.length, query);
      updateSearchNotes(true);

      const sectionNote = document.querySelector('.avian-search-section-head p');
      if (sectionNote) sectionNote.textContent = matches.length > visible.length
        ? `Showing ${visible.length} of ${matches.length} title matches`
        : 'Catalogue title matches';
      return true;
    });
  }

  function init() {
    if (canonicalizeSearchPage()) return;
    normalizeSearchForms();
    normalizeSearchLinks();

    const query = (new URL(location.href).searchParams.get('q') || '').trim();
    if (!query) return;

    if (!isGeneric(query) && normalize(query).length >= 2) {
      renderIndexedFullSearch(query)
        .then((rendered) => {
          if (!rendered) {
            rankVisibleShopifyProducts();
            updateSearchNotes(false);
          }
        })
        .catch(() => {
          rankVisibleShopifyProducts();
          updateSearchNotes(false);
        });
      return;
    }

    rankVisibleShopifyProducts();
    updateSearchNotes(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
